import ArticleList from 'components/articles/ArticleList';
import { MediaPlayer } from 'components/player/MediaPlayer';
import { withRouter } from 'components/shell/WithRouter';
import { ArticleTypeMap } from 'config';
import { isTimerEnabled } from 'helpers';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HomePage from './HomePage';
import Page from './Page';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'types';
import { allowsDevicePlayer, isVideoSatsang } from 'video/articleVideo';
import { VideoArticleTile } from 'components/articles/VideoArticleTile';
import { Alert } from '@mui/material';

function MediaPage(props) {
	let { routeState, isModal, history } = props;
	let { href } = useParams();
	const candidate = useSelector((state: ApplicationState) => href ? state.dataState.articles.byId[href] : undefined);
	const visibleRecord = useSelector((state: ApplicationState) => state.filteredDataState.articles.find((record) => record.id === href));
	const inline = candidate?.mediaType === 'video' && (isVideoSatsang(candidate) || !allowsDevicePlayer(candidate));

	useEffect(() => {
		if (isModal && !inline) {
			isTimerEnabled().then((timerEnabled) => {
				if (routeState.type === 'dhyan' && timerEnabled) {
					MediaPlayer.instance().showTimerView();
				} else {
					MediaPlayer.instance().playAllAudio(href!, routeState.type);
				}
			});
		}
	}, [href, isModal, routeState, inline]);

	if (inline) return <Page title={isVideoSatsang(candidate) ? 'Video Satsang' : ArticleTypeMap[candidate?.articleType ?? ''] ?? 'Video'} includeBottomNavigation dark>
		{visibleRecord ? <VideoArticleTile key={visibleRecord.id} record={visibleRecord} startPlaying /> : <Alert severity="info">This video is unavailable.</Alert>}
	</Page>;

	return (
		<React.Fragment key={'media-player-' + href}>
			{!isModal ? (
				<Page
					title={ArticleTypeMap[routeState.type]}
					includeBottomNavigation
					fullscreen
					dark
					onLoad={async () => {
						let timerEnabled = await isTimerEnabled();
						if (routeState.type === 'dhyan' && timerEnabled) {
							MediaPlayer.instance().showTimerView();
						} else {
							MediaPlayer.instance().playAudio(href!, routeState.type, 0);
						}
						history.navigate('/');
					}}
				>
					{routeState.type === 'dhyan' || routeState.type === 'sandesh' ? <HomePage /> : <ArticleList recordType={routeState.type} />}
				</Page>
			) : (
				<span></span>
			)}
		</React.Fragment>
	);
}

export default withRouter(MediaPage);
